export enum FormatDateEnums {
  MONTH_DATE = "MM-dd-yyyy",
  DATE_MONTH = "dd-MM-yyyy",
  FULL_DATE = "dd-MM-yyyy HH:mm",
  FULL_MONTH = "dd MMMM, yyyy",
  DATE_HOUR_SLASH = "dd/M/yyyy h:mm a",
  FULL_DATE_DAY = "EEEE, d/M/yyyy",
}
